import React from "react"
import DefaultedLoanAccountingForm from './Form'

export default function DefaultedLoanAccountingDetails() {
  return <DefaultedLoanAccountingForm isUpdate={ false } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/DefaultedLoanAccounting/Details.js